import { createQueryAtomFactory } from '~/shared/providers/api/createQueryAtomFactory';

export const brokeredOrderLinkedOrdersQueryAtom = createQueryAtomFactory(
  'brokerage.brokeredOrderLinkedOrders',
  (params: { id: string }) => ({
    brokeredOrder: {
      __args: { id: params.id },
      purchaseOrders: { id: true, lineItems: { unit: true } },
      salesOrders: { id: true },
    },
  }),
  {
    select: (data) => ({
      purchaseOrderIds: (data?.brokeredOrder?.purchaseOrders ?? []).map(
        (po) => po.id,
      ),
      salesOrderIds: (data?.brokeredOrder?.salesOrders ?? []).map(
        (so) => so.id,
      ),
      purchaseOrderPricingUnits: (data?.brokeredOrder?.purchaseOrders ?? [])
        .flatMap((po) => (po.lineItems ?? []).map((li) => li.unit))
        .filter(Boolean) as string[],
    }),
  },
);
